import $ from 'jquery';

$( document ).ready( function() {
	$( '.acf-image-group .image' ).click( function() {
		if ( $( this ).parent().hasClass( 'single' ) ) {
			if ( $( this ).hasClass( 'selected' ) ) {
				$( this ).removeClass( 'selected' );
			} else {
				$( this ).parent().find( '.image' ).removeClass( 'selected' );
				$( this ).addClass( 'selected' );
			}
		} else {
			$( this ).toggleClass( 'selected' );
		}
	} );
} );
